import { Navigate, useParams } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";

/**
 * V231 — Bare language-code router (/ar, /en, /es, /hi, /fi, /da, /pt...).
 *
 * Why: Google was crawling top-level language slugs from our hreflang
 * declarations (`/en/ai-visibility`, `/es/outrank` ...), guessing that
 * the root `/en` must also exist, hitting the `*` catch-all and
 * getting a 200 + homepage shell → soft 404.
 *
 * Behavior:
 *   • Supported langs we actively serve as full locales → redirect to /
 *     (so Google eventually learns there's no bare /en page but doesn't
 *     treat the ping as broken).
 *   • Unsupported / exotic langs (ar, hi, fi, da, pt, es ...) → render
 *     NotFoundPage with noindex so GSC de-lists them.
 *   • Non-ISO strings or longer paths → NotFoundPage.
 */
const SUPPORTED_LANGS = new Set(["sk", "en"]);
const ISO_LANG_RE = /^[a-z]{2}(?:-[a-z]{2})?$/i;

export default function LangRedirectOrNotFound() {
  const { lang } = useParams();
  const normalized = (lang || "").toLowerCase();

  if (ISO_LANG_RE.test(normalized) && SUPPORTED_LANGS.has(normalized)) {
    return <Navigate to="/" replace />;
  }

  // Unknown garbage OR unsupported locale → noindex 404.
  return <NotFoundPage />;
}
